import React, { useState } from "react";
import UserProfileDropdown from "../../components/common/UserProfileDropdown";
import { useNavigate } from "react-router-dom";
import { useWhiteLabel } from "../../contexts/WhiteLabelContext";

interface PatientHeaderProps {
  itemsCount?: number;
  isNavigateCheckout?: boolean;
  navigateLogo?: string;
}

const PatientHeader: React.FC<PatientHeaderProps> = ({
  itemsCount = 0,
  isNavigateCheckout = false,
  navigateLogo = "/patient/dashboard",
}) => {
  const navigate = useNavigate();
  const { brandName, logoUrl, primaryColor } = useWhiteLabel();

  const handleCartClick = () => {
    if (isNavigateCheckout) {
      navigate("/patient/checkout");
    }
  };

  const handleLogoClick = () => {
    navigate(navigateLogo);
  };

  return (
    <>
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div
              className="flex items-center cursor-pointer"
              onClick={handleLogoClick}
            >
              <div className="h-8 w-8 rounded-lg flex items-center justify-center">
                <img
                  // src="/assets/logo.svg"
                  // alt="Gattaca Genomics Logo"
                  // className="h-100 w-100"
                  src={logoUrl}
                  alt={`${brandName} Logo`}
                  className="h-full w-full object-contain"
                  onError={(e) => {
                    // Fallback to default logo if white label logo fails to load
                    e.currentTarget.src = "/assets/logo.svg";
                  }}
                />
              </div>
              <span className="ml-3 text-lg font-semibold text-gray-900">
                Patient Services
              </span>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={handleCartClick}
                className="p-2 text-gray-500 hover:text-gray-700 transition-colors relative"
                style={{
                  color:
                    isNavigateCheckout && itemsCount > 0
                      ? primaryColor
                      : undefined,
                }}
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
                {isNavigateCheckout && itemsCount > 0 && (
                  <span
                    className="absolute -top-1 -right-1 h-5 w-5 text-white text-xs rounded-full flex items-center justify-center"
                    // className="absolute -top-1 -right-1 h-5 w-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center"
                    style={{ backgroundColor: primaryColor }}
                  >
                    {itemsCount}
                  </span>
                )}
              </button>
              <UserProfileDropdown />
            </div>
          </div>
        </div>
      </div>

      {/* Spacer to prevent content from hiding behind fixed header */}
      <div className="h-16"></div>
    </>
  );
};

export default PatientHeader;
